import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';
//
import { dispatch } from '../store';

// ----------------------------------------------------------------------

const initialState = {
  error: null,
  isLoading: false,
  supermarketStoreMappings: [],
  dataPaging: {},
};

const slice = createSlice({
  name: 'supermarket-store-mapping',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET MAPPINGS SUCCESS
    getSupermarketStoreMappingSuccess(state, action) {
      state.isLoading = false;
      state.supermarketStoreMappings = action.payload;
    },

    getDataPaging(state, action) {
      state.isLoading = false;
      state.dataPaging = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function getSupermarketStoreMappings(queryParams) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('supermarket-store-mappings', { params: queryParams });
      const { mappings } = response?.data?.data;

      let newMappings = mappings;
      if (newMappings?.per_page) {
        newMappings = newMappings.data;
      }

      dispatch(slice.actions.getSupermarketStoreMappingSuccess(newMappings));
      dispatch(slice.actions.getDataPaging(mappings));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
